import { __assign, __decorate } from "tslib";
import { observable, makeObservable } from "mobx";
import defaultTheme, { resolveTheme } from "../theme";
import { isNumeric, mergeObjects, querySelector } from "../utils";
import { setRedocLabels } from "./Labels";
export function argValueToBoolean(e, a) {
  return void 0 === e ? a || !1 : "string" == typeof e ? "false" !== e : e;
}

function argValueToNumber(e) {
  return "string" == typeof e ? parseInt(e, 10) : "number" == typeof e ? e : void 0;
}

function argValueToInt(e) {
  return "string" == typeof e ? parseInt(e, 10) : "number" == typeof e ? Math.ceil(e) : void 0;
}

function argValueToExpandLevel(e, a) {
  return void 0 === a && (a = 0), "all" === e ? 1 / 0 : argValueToInt(e) || a;
}

var RedocNormalizedOptions = function () {
  function e(a, t) {
    var r, i, o, l, n, s;
    void 0 === t && (t = {}), Object.defineProperty(this, "theme", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "scrollYOffset", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "hideHostname", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "hideInfoDescription", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "expandResponses", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "requiredPropsFirst", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sortPropsAlphabetically", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sortEnumValuesAlphabetically", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sortOperationsAlphabetically", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sortTagsAlphabetically", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "noAutoAuth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "nativeScrollbars", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "pathInMiddlePanel", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "untrustedDefinition", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "hideDownloadButton", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "disableSearch", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "showChangeLayoutButton", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "onlyRequiredInSamples", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "showConsole", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "sendXUserAgentInTryIt", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "generatedPayloadSamplesMaxDepth", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "showExtensions", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "hideSingleRequestSampleTab", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "hideRequestPayloadSample", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "menuToggle", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "jsonSampleExpandLevel", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "enumSkipQuotes", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "hideSchemaTitles", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "simpleOneOfTypeLabel", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "payloadSampleIdx", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "expandSingleSchemaField", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "schemaExpansionLevel", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "samplesTabsMaxCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "unstable_tryItButtonOverride", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "allowedMdComponents", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "expandDefaultServerVariables", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "maxDisplayedEnumValues", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "ignoreNamedSchemas", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "unstable_ignoreMimeParameters", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "unstable_externalCodeSamples", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "hooks", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "hideSchemaPattern", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), makeObservable(this);
    var u = null === (r = (a = __assign(__assign({}, t), a)).theme) || void 0 === r ? void 0 : r.extensionsHook;
    (null === (i = a.theme) || void 0 === i ? void 0 : i.menu) && !(null === (o = a.theme) || void 0 === o ? void 0 : o.sidebar) && (console.warn('Theme setting "menu" is deprecated. Rename to "sidebar"'), a.theme.sidebar = a.theme.menu), (null === (l = a.theme) || void 0 === l ? void 0 : l.codeSample) && !(null === (n = a.theme) || void 0 === n ? void 0 : n.codeBlock) && (console.warn('Theme setting "codeSample" is deprecated. Rename to "codeBlock"'), a.theme.codeBlock = a.theme.codeSample), this.theme = resolveTheme(mergeObjects({}, defaultTheme, __assign(__assign({}, a.theme), {
      extensionsHook: void 0
    }))), this.theme.mediaQueries = {
      print: "@media print"
    };

    for (var b = 0, d = Object.entries(this.theme.breakpoints); b < d.length; b++) {
      var m = d[b],
          c = m[0],
          p = m[1];
      this.theme.mediaQueries[c] = "@media screen and (min-width: " + p + ")";
    }

    this.theme.extensionsHook = u, setRedocLabels(a.labels), this.scrollYOffset = e.normalizeScrollYOffset(a.scrollYOffset), this.hideHostname = e.normalizeHideHostname(a.hideHostname), this.expandResponses = e.normalizeExpandResponses(a.expandResponses), this.requiredPropsFirst = argValueToBoolean(a.requiredPropsFirst), this.sortPropsAlphabetically = argValueToBoolean(a.sortPropsAlphabetically), this.sortEnumValuesAlphabetically = argValueToBoolean(a.sortEnumValuesAlphabetically), this.sortOperationsAlphabetically = argValueToBoolean(a.sortOperationsAlphabetically), this.sortTagsAlphabetically = argValueToBoolean(a.sortTagsAlphabetically), this.noAutoAuth = argValueToBoolean(a.noAutoAuth), this.nativeScrollbars = argValueToBoolean(a.nativeScrollbars), this.pathInMiddlePanel = argValueToBoolean(a.pathInMiddlePanel), this.untrustedDefinition = argValueToBoolean(a.untrustedDefinition), this.hideDownloadButton = argValueToBoolean(a.hideDownloadButton), this.hideInfoDescription = argValueToBoolean(a.hideInfoDescription), this.disableSearch = argValueToBoolean(a.disableSearch), this.onlyRequiredInSamples = argValueToBoolean(a.onlyRequiredInSamples), this.generatedPayloadSamplesMaxDepth = argValueToInt(a.generatedPayloadSamplesMaxDepth) || 8, this.sendXUserAgentInTryIt = argValueToBoolean(a.sendXUserAgentInTryIt), this.showExtensions = e.normalizeShowExtensions(a.showExtensions), this.hideSingleRequestSampleTab = argValueToBoolean(a.hideSingleRequestSampleTab), this.hideRequestPayloadSample = argValueToBoolean(a.hideRequestPayloadSample), this.menuToggle = argValueToBoolean(a.menuToggle, !0), this.jsonSampleExpandLevel = argValueToExpandLevel(a.jsonSampleExpandLevel, 2), this.enumSkipQuotes = argValueToBoolean(a.enumSkipQuotes), this.hideSchemaTitles = argValueToBoolean(a.hideSchemaTitles), this.simpleOneOfTypeLabel = argValueToBoolean(a.simpleOneOfTypeLabel), this.payloadSampleIdx = e.normalizePayloadSampleIdx(a.payloadSampleIdx), this.expandSingleSchemaField = argValueToBoolean(a.expandSingleSchemaField), this.schemaExpansionLevel = argValueToExpandLevel(a.schemaExpansionLevel), this.samplesTabsMaxCount = argValueToInt(a.samplesTabsMaxCount) || 5, this.unstable_tryItButtonOverride = a.unstable_tryItButtonOverride || null, this.unstable_ignoreMimeParameters = argValueToBoolean(a.unstable_ignoreMimeParameters), this.allowedMdComponents = a.allowedMdComponents || {}, this.expandDefaultServerVariables = argValueToBoolean(a.expandDefaultServerVariables), this.maxDisplayedEnumValues = argValueToNumber(a.maxDisplayedEnumValues);
    var h = Array.isArray(a.ignoreNamedSchemas) ? a.ignoreNamedSchemas : null === (s = a.ignoreNamedSchemas) || void 0 === s ? void 0 : s.split(",").map(function (e) {
      return e.trim();
    });
    this.ignoreNamedSchemas = new Set(h), this.unstable_externalCodeSamples = a.unstable_externalCodeSamples || [], this.hooks = a.hooks || {}, this.hideSchemaPattern = argValueToBoolean(a.hideSchemaPattern);
  }

  return Object.defineProperty(e, "normalizeExpandResponses", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      if ("all" === e) return "all";

      if ("string" == typeof e) {
        var a = {};
        return e.split(",").forEach(function (e) {
          a[e.trim()] = !0;
        }), a;
      }

      return void 0 !== e && console.warn('expandResponses must be a string but received value "' + e + '" of type ' + typeof e), {};
    }
  }), Object.defineProperty(e, "normalizeHideHostname", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      return !!e;
    }
  }), Object.defineProperty(e, "normalizeScrollYOffset", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      if ("string" == typeof e && !isNumeric(e)) {
        var a = querySelector(e);
        a || console.warn("scrollYOffset value is a selector to non-existing element. Using offset 0 by default");
        var t = a && a.getBoundingClientRect().bottom || 0;
        return function () {
          return t;
        };
      }

      return "number" == typeof e || isNumeric(e) ? function () {
        return "number" == typeof e ? e : parseFloat(e);
      } : "function" == typeof e ? function () {
        var a = e();
        return "number" != typeof a && console.warn('scrollYOffset should return number but returned value "' + a + '" of type ' + typeof a), a;
      } : (void 0 !== e && console.warn("Wrong value for scrollYOffset ReDoc option: should be string, number or function"), function () {
        return 0;
      });
    }
  }), Object.defineProperty(e, "normalizeShowExtensions", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      if (void 0 === e) return !1;
      if ("" === e) return !0;
      if ("string" != typeof e) return e;

      switch (e) {
        case "true":
          return !0;

        case "false":
          return !1;

        default:
          return e.split(",").map(function (e) {
            return e.trim();
          });
      }
    }
  }), Object.defineProperty(e, "normalizePayloadSampleIdx", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function value(e) {
      return "number" == typeof e ? Math.max(0, e) : "string" == typeof e && isFinite(e) ? parseInt(e, 10) : 0;
    }
  }), __decorate([observable], e.prototype, "showConsole", void 0), e;
}();

export { RedocNormalizedOptions };